import React from 'react';
import PropTypes from 'prop-types';
import * as shapes from '../../shapes';
import * as productsShapes from '../../../products/shapes';
import Item from '../containers/ListItem';

const List = ({ items, selectedItems, addItem, color, isProducts }) => (
  <ul className="layout">
    {items.map((item) => {
      const selected = selectedItems.includes(item.id);

      return (
        <Item
          key={item.id}
          item={item}
          selected={selected}
          onClick={() => addItem(item)}
          color={color}
          isProduct={isProducts}
        />
      );
    })}
  </ul>
);
List.propTypes = {
  items: PropTypes.oneOfType([
    productsShapes.products,
    shapes.services,
    shapes.discounts,
  ]),
  selectedItems: PropTypes.arrayOf(PropTypes.string),
  addItem: shapes.handler,
  color: shapes.string,
  isProducts: PropTypes.bool,
};
List.defaultProps = {
  items: [],
  selectedItems: [],
  addItem: () => null,
  color: '',
  isProducts: false,
};

export default List;
